import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Form, Button, Alert, Spinner } from 'react-bootstrap';
import { vatAPI } from '../utils/api';

const VatManagement = () => {
  const [vatRate, setVatRate] = useState('7.00');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    loadVatSetting();
  }, []);

  const loadVatSetting = async () => {
    try {
      setLoading(true);
      setError('');
      const res = await vatAPI.get();
      setVatRate(res.data.data.rate);
    } catch (err) {
      setError(err.response?.data?.message || 'เกิดข้อผิดพลาดในการโหลดข้อมูล');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    // Validation
    const rate = parseFloat(vatRate);
    if (isNaN(rate) || rate < 0 || rate > 100) {
      setError('อัตรา VAT ต้องอยู่ระหว่าง 0-100');
      return;
    }

    setSaving(true);

    try {
      await vatAPI.update({ rate });
      setSuccess('บันทึกอัตรา VAT สำเร็จ');
    } catch (err) {
      setError(err.response?.data?.message || 'เกิดข้อผิดพลาดในการบันทึก');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <Container fluid className="main-content">
        <div className="text-center py-5">
          <Spinner animation="border" variant="primary" />
          <p className="mt-3 text-muted">กำลังโหลดข้อมูล...</p>
        </div>
      </Container>
    );
  }

  return (
    <Container fluid className="main-content">
      <Row className="mb-4">
        <Col>
          <h2>
            <i className="bi bi-percent me-2"></i>
            ตั้งค่า VAT
          </h2>
          <p className="text-muted">กำหนดอัตราภาษีมูลค่าเพิ่ม (VAT)</p>
        </Col>
      </Row>

      {error && (
        <Alert variant="danger" dismissible onClose={() => setError('')}>
          {error}
        </Alert>
      )}

      {success && (
        <Alert variant="success" dismissible onClose={() => setSuccess('')}>
          {success}
        </Alert>
      )}

      <Row className="justify-content-center">
        <Col md={6}>
          <Card>
            <Card.Body className="p-4">
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-4">
                  <Form.Label>
                    <h5>
                      <i className="bi bi-percent me-2"></i>
                      อัตรา VAT (%)
                    </h5>
                  </Form.Label>
                  <Form.Control
                    type="number"
                    value={vatRate}
                    onChange={(e) => setVatRate(e.target.value)}
                    placeholder="7.00"
                    step="0.01"
                    min="0"
                    max="100"
                    required
                    style={{ fontSize: '1.5rem', padding: '0.75rem' }}
                  />
                  <Form.Text className="text-muted">
                    ระบุอัตราภาษีมูลค่าเพิ่มเป็นเปอร์เซ็นต์ (0-100)
                  </Form.Text>
                </Form.Group>

                <div className="d-grid">
                  <Button
                    type="submit"
                    variant="primary"
                    size="lg"
                    disabled={saving}
                  >
                    {saving ? (
                      <>
                        <Spinner animation="border" size="sm" className="me-2" />
                        กำลังบันทึก...
                      </>
                    ) : (
                      <>
                        <i className="bi bi-save me-2"></i>
                        บันทึก
                      </>
                    )}
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default VatManagement;
